<template>
    <div class="login flex-box">
        <div class="login-title flex-box align-center">
            <img src="../assets/login-title.png" class="login-title-img">
        </div>
        <div class="login-box">
            <div class="login-box-ti">{{ activeLoginType === 'password' ? '账号密码登录' : '验证码登录' }}</div>
            <a-form-model
                    class="login-form"
                    ref="loginForm"
                    :model="form"
                    :rules="rules"
                    :label-col="{span: 0}"
                    :wrapper-col="{span: 25}">
                <a-form-model-item label="" prop="tel">
                    <a-input size="large" v-model="form.tel" :placeholder="activeLoginType === 'password' ? '账号/手机号' : '手机号'" @keyup.enter="submitLogin">
                        <a-icon slot="prefix" type="user"/>
                    </a-input>
                </a-form-model-item>
                <a-form-model-item label="" prop="password" v-if="activeLoginType === 'password'">
                    <a-input size="large" type="password" v-model="form.password" placeholder="密码" @keyup.enter="submitLogin">
                        <a-icon slot="prefix" type="lock" />
                    </a-input>
                </a-form-model-item>
                <a-form-model-item label="" prop="code" v-if="activeLoginType === 'code'">
                    <a-input size="large" v-model="form.code" placeholder="验证码" @keyup.enter="submitLogin">
                        <a-icon slot="prefix" type="lock" />
                        <template slot="suffix">
                            <a-button 
                                :disabled="countdown > 0"
                                @click="getCode"
                                size="small"
                                class="code-btn"
                            >
                                {{ countdown > 0 ? `${countdown}s后重发` : '获取验证码' }}
                            </a-button>
                        </template>
                    </a-input>
                </a-form-model-item>
            </a-form-model>
            <a-button size="large" type="primary" block @click="submitLogin">登录</a-button>
            <a-button size="large" type="default" block @click="switchLoginType" style="margin-top: 12px;">
                {{ activeLoginType === 'password' ? '验证码登录' : '账号密码登录' }}
            </a-button>
            <div class="login-loading" v-show="loading">
                <a-spin tip="正在登陆...">
                    <a-icon slot="indicator" type="loading" style="font-size: 24px" spin />
                </a-spin>
            </div>
<!--            <a-button size="large" type="primary" block @click="permanentAuth">永久授权</a-button>-->
            <a :href="loginUrl" class="wx-login-btn">
                <img src="https://open.work.weixin.qq.com/service/img?id=wwd1e47830fca25b7e&t=login&c=white&s=large" srcset="https://open.work.weixin.qq.com/service/img?id=wwd1e47830fca25b7e&t=login&c=white&s=large@2x 2x" referrerpolicy="unsafe-url" alt="企业微信">
            </a>
        </div>
    </div>
</template>

<script>
    import {setToken, cleanToken} from "../common/js/storage";
    import {getWorkWxLoginUrl} from "../common/js/auth";
    import conf from "../common/js/config";

    export default {
        name: "Login",
        data() {
            return {
                activeLoginType: 'code', // 登录方式：password-密码登录，code-验证码登录
                form: {},
                rules: {
                    tel: [{ required: true, message: '请输入账号', trigger: 'blur' }],
                    password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
                    code: [{ required: true, message: '请输入验证码', trigger: 'blur' }]
                },
                loading: false,
                countdown: 0, // 验证码倒计时
                img: null,
                token: null,
                loginUrl: null
            }
        },
        created() {
            cleanToken();
            this.$store.commit("setUser", null);
            this.loginUrl = getWorkWxLoginUrl(this.$route.query.r || "/");
        },
        beforeDestroy() { 
            this.timer && clearInterval(this.timer);
        },
        methods: {
            permanentAuth() {
                this.$axios('/admin/login/get-code').then(res => {
                    let redirect_uri = encodeURIComponent(`${location.protocol}//${location.host}/auth`);
                    let url = `https://open.work.weixin.qq.com/3rdapp/install?suite_id=${conf.SuiteID}&pre_auth_code=${res}&redirect_uri=${redirect_uri}&state=1`;
                    location.replace(url);
                })
            },
            /**
             * 切换登录方式
             */
            switchLoginType() {
                this.activeLoginType = this.activeLoginType === 'password' ? 'code' : 'password';
                // 重置表单
                this.$refs.loginForm.resetFields();
            },
            /**
             * 获取验证码
             */
            getCode() {
                // 验证手机号
                if (!this.form.tel) {
                    this.$message.warning('请输入手机号');
                    return;
                }
                // 开始倒计时
                this.countdown = 59;
                this.timer = setInterval(() => {
                    this.countdown--;
                    if (this.countdown <= 0) {
                        clearInterval(this.timer);
                    }
                }, 1000);
                // 发送验证码请求
                this.$axios({
                    url: '/user/get-verify-code',
                    method: "POST",
                    data: {
                        mobile: this.form.tel
                    }
                }).then(res => {
                    if (res.error === 0) {
                        this.$message.success('验证码发送成功');
                    } else {
                        this.$message.error(res.msg);
                    }
                }).catch((error) => {
                    console.error('验证码发送失败:', error);
                    this.$message.error('验证码发送失败');
                });
            },
            /**
             * 提交登录
             */
            submitLogin() {
                this.$refs.loginForm.validate(valid => {
                    if (valid) {
                        let form = this.form;
                        this.loading = true;
                        
                        // 根据登录类型选择不同的接口
                        const loginData = this.activeLoginType === 'password' ? 
                            { tel: form.tel, password: form.password } : 
                            { mobile: form.tel, code: form.code };
                        
                        const loginUrl = this.activeLoginType === 'password' ? 
                            '/admin/login/auth' : 
                            '/admin/login/mobile-auth';
                        
                        this.$axios({
                            url: loginUrl,
                            method: "POST",
                            data: loginData
                        }).then(res => {
                            this.loading = false;
                            let code;
                            if (this.activeLoginType === 'password') {
                                code = res.code;
                            } else {
                                code = res.error;
                            }
                            if(code == 0) {
                                this.$message.success('登录成功');
                                setToken(res);
                                this.$router.replace({path: '/', query: this.$route.query});
                            } else {
                                this.$message.error(res.msg);
                            }
                        }).catch(() => {
                            this.loading = false;
                            // this.$message.error("登录失败");
                        });
                    } else {
                        return false;
                    }
                });
            }
        }
    }
</script>

<style scoped lang="less">
    .login {
        align-items: flex-start;
        justify-content: center;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: url(../assets/login-back.jpg) center / cover no-repeat;
    }
    .login-title {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        padding: 0 24px;
        height: 60px;
        background: rgba(0, 0, 0, 0.5);
        backdrop-filter: blur(3px);
    }
    .sep {
        margin: 0 12px;
        width: 1px;
        height: 16px;
        background-color: @text-color-secondary;
    }
    .login-box {
        position: relative;
        margin-top: 200px;
        padding: @padding-lg;
        background: rgba(255, 255, 255, 0.70);
        backdrop-filter: blur(2px);
    }
    .login-box-ti {
        font-size: 20px;
        text-align: center;
    }
    .login-form {
        margin-top: 24px;
        width: 300px;
    }
    .code-img-box {
        margin-right: -12px;
        position: relative;
        width: 76px;
        height: 38px;
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
        overflow: hidden;
        font-size: 0;
        text-align: center;
    }
    .code-img {
        width: 100%;
        height: 100%;
    }
    .login-loading {
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(255,255,255,.6);
        cursor: pointer;
    }
    .wx-login-btn {
        display: block;
        margin-top: 16px;
    }
    .code-btn {
        margin-right: -8px;
    }
</style>